/**
=========================================================
* Trust Cargo - wall board selection
=========================================================

* Which containers and orders the wall board shows.
*
* The flag lives on the row itself, so the choice is the same on every
* screen and on the board, and survives a refresh. When nothing has been
* picked the board falls back to showing everything - an empty wall screen
* looks broken, and "not chosen yet" is not worth a blank display.
*/

import axios from "axios";

const API = "https://trust-cargo.co/anas_backend/api/v2";

/**
 * Put a row on the board, or take it off.
 *
 * Returns true when it stuck. Never throws: this is a convenience toggle on
 * a list, and a failure must not take the page down with it.
 */
export default async function toggleOnBoard(type, id, on) {
  try {
    await axios.post(
      `${API}/board/toggle`,
      { type, id, on },
      { headers: { Accept: "application/json", "Content-Type": "application/json" } }
    );
    return true;
  } catch (e) {
    // eslint-disable-next-line no-alert
    window.alert(e?.response?.data?.message || "Could not change the board");
    return false;
  }
}

/** The row action, shared by the Containers and Orders screens. */
export function boardAction(type, row, onDone) {
  const on = Boolean(row.on_board);

  return {
    icon: on ? "cast_connected" : "cast",
    label: on ? "On the wall board - click to remove" : "Show on the wall board",
    tone: on ? "primary" : "default",
    onClick: async () => {
      if (await toggleOnBoard(type, row.id, !on)) onDone();
    },
  };
}
